export default __webpack_public_path__ + "static/media/title.d2e47b70.svg";